import React from 'react';
import { cn } from 'helpers/utils/classnames';

type DiscountBadgeProps = {
  title?: string;
  description?: string;
};

function DiscountBadge({ title, description }: DiscountBadgeProps) {
  if (!title && !description) return null;

  return (
    <section className="mt-8">
      {title && <p className="font-bold text-[#B19A6A]">{title}</p>}
      {description && (
        <p className={cn('text-sm leading-snug text-[#222222]', title && 'mt-0.5')}>
          {description.split('\n').map((line, index, array) => (
            <React.Fragment key={index}>
              {line}
              {index < array.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      )}

    </section>
  );
}

export default DiscountBadge;
